import { makeObservable, action, observable, computed } from 'mobx'
import WorkspacePostingOpportunityViewModel from './WorkspacePostingOpportunityViewModel'
import { task } from 'mobx-task'
import { AlertFactory, AlertState } from '../../alerts/Alert'
import WorkspaceOpportunitiesAdapter from './WorkspaceOpportunitiesAdapter'
import { WorkspacePostingStatus } from './WorkspacePostingOpportunity'

export default class WorkspaceOpportunityDetailsViewModel {
  /**
   * The selected opportunity.
   */
  selected: WorkspacePostingOpportunityViewModel | null = null

  constructor(
    private workspacePostingOpportunityPort: WorkspaceOpportunitiesAdapter,
    private newAlert: AlertFactory,
  ) {
    makeObservable(this, {
      select: action.bound,
      deselect: action.bound,
      selected: observable,
      disabled: computed,
      selectedIsActive: computed,
    })
  }

  select(opportunityViewModel: WorkspacePostingOpportunityViewModel | null) {
    this.selected = opportunityViewModel
  }

  deselect() {
    this.select(null)
  }

  get selectedIsActive() {
    return this.selected?.opportunity.status === WorkspacePostingStatus.Active
  }

  /**
   * Whether selection is disabled.
   */
  get disabled() {
    return this.apply.pending || this.withdraw.pending
  }

  apply = task.resolved(async () => {
    if (!this.selected) {
      return
    }
    try {
      await this.workspacePostingOpportunityPort.applyToOpportunity(
        this.selected.opportunityId,
      )
    } catch (error) {
      this.newAlert()
        .withState(AlertState.Error)
        .saying('Error!', 'Failed to apply to opportunity!')
        .show()
    }
  })

  withdraw = task.resolved(async () => {
    if (!this.selected) {
      return
    }
    try {
      await this.workspacePostingOpportunityPort.withdrawFromOpportunity(
        this.selected.opportunityId,
      )
      if (!this.selectedIsActive) {
        this.deselect()
      }
    } catch (error) {
      this.newAlert()
        .withState(AlertState.Error)
        .saying('Error!', 'Failed to withdraw from opportunity!')
        .show()
    }
  })
}
